import MarkdownIt from 'markdown-it'

type AllowedEnableRule = 'list' | 'linkify'

function allLinksOpenInNewTabPlugin(markdown: MarkdownIt): void {
  markdown.renderer.rules.link_open = (tokens, index, options, _env, self) => {
    tokens[index]?.attrSet('target', '_blank')

    return self.renderToken(tokens, index, options)
  }
}

export const parseUserMarkdown = (
  markdown: string,
  { enabled = [] }: { enabled?: readonly AllowedEnableRule[] } = {},
): string => {
  const parser = new MarkdownIt('zero', { linkify: true })
    .enable([
      'emphasis', // allow *bold* and _italic_
      ...enabled,
    ])
    .use(allLinksOpenInNewTabPlugin)

  return parser.render(markdown)
}
